import { restDelete, restGet, restPost } from "apiCommandsExecutor/rest";

import {
    CheckoutSettingsDto,
    InvoiceServiceOrderDto,
    ServiceOrderDto,
    ServiceOrdersPageDto,
} from "./restModels";
import { CreateServiceOrderRequestDto } from "./restRequests";

// ===== История оплат тарифа (REST /api/rest/warehouse/v1) =====
// Заведение бэк берёт из аккаунта; выборка отсортирована от новых к старым.

export const getServiceOrders = (skip: number, limit: number) =>
    restGet<ServiceOrdersPageDto>("/service-orders", { skip, limit });

export const createServiceOrder = (body: CreateServiceOrderRequestDto) =>
    restPost<ServiceOrderDto>("/service-orders", body);

// Публичный ключ виджета оплаты картой — тянем только при открытии диалога оплаты.
export const getCheckoutSettings = () =>
    restGet<CheckoutSettingsDto>("/service-orders/checkout-settings");

// Акт формируется один раз: повторный вызов отдаёт уже готовую ссылку.
export const generateInvoiceAct = (invoiceId: string) =>
    restPost<InvoiceServiceOrderDto>(`/service-orders/invoices/${invoiceId}/act`);

export const cancelInvoice = (invoiceId: string) =>
    restDelete<InvoiceServiceOrderDto>(`/service-orders/invoices/${invoiceId}`);
